import { useGetTheme } from '@pba/react-theme';
import type { ReactNode } from 'react';
import { Flex, ReadMore } from 'ui';
import type { MessageDirection } from '../../../types';
import type { ChatMessageBubbleLayout } from '../hooks';

type P = {
  children: ReactNode;
  direction: MessageDirection;
  layout: ChatMessageBubbleLayout;
};

const bubbleMaxHeight = 560;

const getReadMoreCollapseHeight = (layout: ChatMessageBubbleLayout, paddingXs: number, paddingMs: number) => {
  switch (layout) {
    case 'attachment-only':
      return bubbleMaxHeight - 2 * paddingMs;
    case 'mixed':
      return bubbleMaxHeight - paddingMs - paddingXs;
    case 'text-only':
      return bubbleMaxHeight - 2 * paddingXs;
  }
};

const ChatMessageBubbleReadMore = ({ children, direction, layout }: P) => {
  const { spacing } = useGetTheme();
  const paddingXs = spacing.xs.value;
  const paddingMs = spacing.ms.value;

  return (
    <ReadMore
      buttonPaddingBottom={false}
      buttonType={direction === 'outgoing' ? 'link-inverted' : 'link-primary'}
      collapse={{
        height: getReadMoreCollapseHeight(layout, paddingXs, paddingMs),
      }}
      fade={direction === 'outgoing' ? 'primary' : 'light'}
    >
      <Flex gap="xs" vertical>
        {children}
      </Flex>
    </ReadMore>
  );
};

export default ChatMessageBubbleReadMore;
